import { render, staticRenderFns } from "./RemesasPersonalTable.vue?vue&type=template&id=bf7f46ba&scoped=true"
import script from "./RemesasPersonalTable.vue?vue&type=script&lang=js"
export * from "./RemesasPersonalTable.vue?vue&type=script&lang=js"
import style0 from "./RemesasPersonalTable.vue?vue&type=style&index=0&id=bf7f46ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7f46ba",
  null
  
)

export default component.exports